import { AnyZodObject, z } from 'zod'

export function setWithExpiry<T extends AnyZodObject>(
  window: Window,
  key: string,
  value: any,
  schema: T,
  expiry: Date
) {
  const item = {
    value: schema.parse(value),
    expiry: expiry.getTime(),
  }
  window.localStorage.setItem(key, JSON.stringify(item))
}

export function getWithExpiry<T extends AnyZodObject>(
  window: Window,
  key: string,
  schema: T
): z.infer<T> | null {
  const itemStr = window.localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  const parsedValue = schema.safeParse(item.value)
  if (parsedValue.success) {
    return parsedValue.data
  }
  return null
}
